import styled from 'styled-components'

export const InfoGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.small};
`

export const BooleanIndicator = styled.span<{ $value: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.micro};
  color: ${({ theme, $value }) =>
    $value ? theme.colors.success : theme.colors.text.tertiary};
`
